import { render } from "./ThisSiteView.vue?vue&type=template&id=4d274d8b&scoped=true"
import script from "./ThisSiteView.vue?vue&type=script&lang=js"
export * from "./ThisSiteView.vue?vue&type=script&lang=js"

import "./ThisSiteView.vue?vue&type=style&index=0&id=4d274d8b&scoped=true&lang=css"

import exportComponent from "/home/dre/personalsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d274d8b"]])

export default __exports__